import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { PageRecovery } from './components/PageRecovery'
import { isBundledNative } from './lib/serverOrigin'
import { dismissBootSplash } from './lib/bootSplash'
import { watchViewportHeight } from './lib/viewportHeight'
import './styles.css'

// 跟随可视视口高度（iOS 键盘收起后不会留白带；旋转/地址栏变化也一样）。
watchViewportHeight()

createRoot(document.getElementById('root')!).render(<StrictMode><PageRecovery><App /></PageRecovery></StrictMode>)

// React 已挂载：淡出并移除 index.html 里的启动页。
dismissBootSplash()

// 离线阅读需要页面静态资源；不依赖用户先开启 Web Push。
if(!isBundledNative() && 'serviceWorker' in navigator) void navigator.serviceWorker.register('/sw.js').catch(()=>{})
